import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-59cdc2d8"), n = n(), _popScopeId(), n); };
var _hoisted_1 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { id: "modals" }, null, -1); });
var _hoisted_2 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { id: "tooltips" }, null, -1); });
import { computed, onBeforeUnmount, onMounted, watch } from 'vue';
import { useRoute } from "vue-router";
import GlobalModals from './components/BaseGlobalModals.vue';
import { AuthEvents } from '@common/modules/auth';
import { primaryStyles } from '@common/utils/Colors/Colors';
import BaseSidebarNav from '@student/components/BaseSidebarNav.vue';
import { CoreStore, CourseStore, } from '@student/modules/store';
import { useEventBus, useMounted } from '@vueuse/core';
import { ChatStore, PartnerProgramStore } from '@common/stores';
import { openWsConnection, sendMessage } from '@common/api/ws/websocketInstance';
import { EventBusEnum } from '@common/enums/eventBus.enum';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Index',
    setup: function (__props) {
        var isMounted = useMounted();
        var route = useRoute();
        var busSignIn = useEventBus(AuthEvents.AUTH_SIGNED_IN);
        var busSignOut = useEventBus(AuthEvents.AUTH_SIGNED_OUT);
        var busWsConnected = useEventBus(EventBusEnum.WEBSOCKET_CONNECTED);
        var school = computed(function () { return CoreStore.school; });
        var schoolId = computed(function () { return CoreStore.school.id; });
        var styles = computed(function () {
            var primaryColor = school.value && school.value.primaryColor ? school.value.primaryColor : '#17b198';
            return primaryStyles(primaryColor);
        });
        var userId = computed(function () { return CoreStore.user.id; });
        var isLanding = computed(function () {
            return route.name === 'courseLanding' || route.name === 'courseAbout' || route.name === 'courseAboutOld';
        });
        watch(userId, function (v) {
            if (!v)
                return;
            openWsConnection();
        }, { immediate: true });
        var onWsConnected = function () {
            sendMessage(JSON.stringify({
                event: 'join_room_school',
                data: {
                    schoolId: schoolId.value
                }
            }));
        };
        onMounted(function () {
            var _a;
            (_a = document.querySelector('#page-loader')) === null || _a === void 0 ? void 0 : _a.remove();
            var clear = function () {
                CourseStore.clearStoreState();
                ChatStore.clearStoreState();
                PartnerProgramStore.clearStoreState();
            };
            busSignIn.on(clear);
            busSignOut.on(clear);
            busWsConnected.on(onWsConnected);
        });
        onBeforeUnmount(function () {
            busWsConnected.off(onWsConnected);
        });
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
                    default: _withCtx(function () { return [
                        _createTextVNode(" :root { " + _toDisplayString(styles.value) + " } ", 1)
                    ]; }),
                    _: 1
                })),
                (_unref(isMounted))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([!isLanding.value && 'pt-10 lg:pt-0', "page-container"])
                    }, [
                        _createVNode(BaseSidebarNav, { class: "page-nav" }),
                        _createVNode(_component_router_view)
                    ], 2))
                    : _createCommentVNode("", true),
                _hoisted_1,
                _hoisted_2,
                (_unref(isMounted))
                    ? (_openBlock(), _createBlock(GlobalModals, { key: 1 }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
